import { mtnTheme } from "./demoThemes/mtnTheme";

export const demoTheme = mtnTheme;
